export enum FlowOrigination {
  UserManagement,
  Requests
}
